import { render, staticRenderFns } from "./BtnFiltros.vue?vue&type=template&id=f24af8b6&"
import script from "./BtnFiltros.vue?vue&type=script&lang=ts&"
export * from "./BtnFiltros.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports